import React from "react";

const StrategyAssesmentTwoMain = () => {
    return (
        <div>
            <div>
                <div className="row mx-2">
                    {/* LEFT SIDE DIV  */}
                    <div className="col-3">
                        <div
                            className=" text-danger text-center border border-danger"
                            style={{ background: "#e8c8b0" }}
                        >
                            <h3 className="p-1">Market Size (INR Cr) FY22</h3>
                            <h1 className="p-1 text-dark">2,000</h1>
                        </div>
                        <div
                            className=" text-danger text-center my-3 border border-danger text-dark"
                            style={{ background: "#e8c8b0" }}
                        >
                            <p className="py-4">
                                Lorem ipsum dolor sit amet consectetur,
                                adipisicing elit. Odio quod non maiores libero.
                            </p>
                        </div>
                        <div
                            className=" text-danger text-center my-3 border border-danger"
                            style={{ background: "#e8c8b0" }}
                        >
                            <h3 className="p-1">Market Size (INR Cr) FY22</h3>
                            <h1 className="p-1 text-dark">2,000</h1>
                        </div>
                        <div
                            className=" text-danger text-center my-3 border border-danger"
                            style={{ background: "#e8c8b0" }}
                        >
                            <p className="py-4">
                                Lorem ipsum dolor sit amet consectetur,
                                adipisicing elit. Odio quod non maiores libero.
                            </p>
                        </div>
                    </div>

                    {/* RIGHT SIDE dIV */}

                    <div className="col-9">
                        <div>
                            <table class="table text-left table-bordered">
                                <thead
                                    className="text-dark text-center"
                                    style={{ background: "#F5C4AF" }}
                                >
                                    <tr>
                                        <th
                                            scope="col"
                                            style={{ width: "27%" }}
                                        >
                                            Paramters
                                        </th>
                                        <th
                                            // colSpan={2}
                                            className="text-center"
                                            scope="col"
                                            style={{ width: "77%" }}
                                        >
                                            Observations
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-between text-white">
                            <div>
                                <h4 className="text-primary">
                                    Competitive Positioning
                                </h4>
                            </div>

                            <div className="d-flex justify-content-end text-white">
                                <div
                                    className="px-5 py-2 "
                                    style={{ background: "#E66C37" }}
                                >
                                    Competitive Disadvantage
                                </div>
                                <div
                                    className="px-5 py-2 mx-4 "
                                    style={{ background: "#F3F300" }}
                                >
                                    {" "}
                                    <p className="text-dark m-0">
                                        Netural
                                    </p>{" "}
                                </div>
                                <div
                                    className="px-5 py-2 "
                                    style={{ background: "#00BD19" }}
                                >
                                     Competitive Advantage
                                </div>
                            </div>
                        </div>

                        <div>
                            <table class="table text-left table-bordered">
                                <thead
                                    className="text-dark text-center"
                                    style={{ background: "#F5C4AF" }}
                                >
                                    <tr>
                                        <th
                                            scope="col"
                                            style={{ width: "27%" }}
                                        >
                                            Paramters
                                        </th>
                                        <th
                                            // colSpan={2}
                                            className="text-center"
                                            scope="col"
                                            style={{ width: "77%" }}
                                        >
                                            Observations
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                            Lorem ipsum, dolor sit amet
                                            consectetur adipisicing elit. In
                                            provident ex odio. Error at commodi
                                            asperiores dolores quo dolor porro.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StrategyAssesmentTwoMain;
